/**
 * Simple FAQ Accordion
 * Supports multiple sections independently
 */
(function () {
  var MOBILE_BREAKPOINT = 989;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function initFaqList(root) {
    if (!root || root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    var items = root.querySelectorAll('.faq-list__item-details');

    function closeItem(item) {
      item.classList.remove('faq-list__item-details--open');
      var content = item.querySelector('.faq-list__item-content-wrap');
      if (content) content.style.maxHeight = '0';
      var header = item.querySelector('.faq-list__item-header');
      if (header) header.setAttribute('aria-expanded', 'false');
    }

    function closeItemInstant(item) {
      item.classList.remove('faq-list__item-details--open');
      var content = item.querySelector('.faq-list__item-content-wrap');
      if (content) {
        content.style.transition = 'none';
        content.offsetHeight; // force reflow so transition:none is committed
        content.style.maxHeight = '0';
        requestAnimationFrame(function () { content.style.transition = ''; });
      }
      var header = item.querySelector('.faq-list__item-header');
      if (header) header.setAttribute('aria-expanded', 'false');
    }

    function openItem(item) {
      item.classList.add('faq-list__item-details--open');
      var content = item.querySelector('.faq-list__item-content-wrap');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
      var header = item.querySelector('.faq-list__item-header');
      if (header) header.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
        var top = item.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 50);
    }

    function closeAllExcept(current) {
      items.forEach(function (item) {
        if (item !== current) closeItemInstant(item);
      });
    }

    // Initialize items
    items.forEach(function (item) {
      var content = item.querySelector('.faq-list__item-content-wrap');
      if (item.classList.contains('faq-list__item-details--open')) {
        if (content) content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        if (content) content.style.maxHeight = '0';
      }

      var header = item.querySelector('.faq-list__item-header');
      if (!header) return;

      header.addEventListener('click', function () {
        var isOpen = item.classList.contains('faq-list__item-details--open');

        // Toggle current
        if (isOpen) {
          closeItem(item);
        } else {
          closeAllExcept(item);
          openItem(item);
        }
      });

      // Keyboard support
      header.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          header.click();
        }
      });
    });
  }

  function initAllFaqs() {
    var roots = document.querySelectorAll('.section-faq-list .faq-list');
    roots.forEach(initFaqList);
  }

  window.addEventListener('resize', function () {
    var roots = document.querySelectorAll('.section-faq-list .faq-list');
    roots.forEach(function (root) {
      var items = root.querySelectorAll('.faq-list__item-details');
      if (isMobile()) {
        items.forEach(function (item) {
          item.classList.remove('faq-list__item-details--open');
          var content = item.querySelector('.faq-list__item-content-wrap');
          if (content) content.style.maxHeight = '0';
        });
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFaqs);
  } else {
    initAllFaqs();
  }

  // Shopify section reload
  document.addEventListener('shopify:section:load', function (evt) {
    var section = evt.target;
    if (!section.classList.contains('section-faq-list')) return;
    var root = section.querySelector('.faq-list');
    if (root) {
      root.removeAttribute('data-faq-init');
      initFaqList(root);
    }
  });
})();